// Shared unread-count state + polling for game notifications (VIVA-82).
// Polls every 60s, and refreshes on window focus / tab becoming visible / route change.

const POLL_INTERVAL_MS = 60_000

export const GAME_NOTIFICATION_TEXT: Record<string, { label: string; hint?: string }> = {
  MATCH_INVITE: { label: 'دعوت به مچ', hint: 'برای پذیرش یا رد دعوت وارد شوید' },
  JOIN_REQUEST: { label: 'درخواست پیوستن جدید', hint: 'قبول یا رد کنید' },
  REQUEST_ACCEPTED: { label: 'درخواست شما قبول شد' },
  REQUEST_REJECTED: { label: 'درخواست شما رد شد' },
  TEAMMATE_INVITE: { label: 'دعوت هم‌تیمی' },
  LEAGUE_INVITE: { label: 'افزودن به لیگ' },
  RESERVATION_REMINDER: { label: 'یادآوری رزرو' },
  TEAMMATE_ACCEPTED: { label: 'هم‌تیمی درخواست را پذیرفت' },
  TEAMMATE_REJECTED: { label: 'هم‌تیمی درخواست را رد کرد' },
  SCORE_SUBMITTED: { label: 'نتیجه ثبت شد', hint: 'لطفاً تأیید کنید' },
  SCORE_CONFIRM_REQUIRED: { label: 'نتیجه ثبت شد', hint: 'لطفاً تأیید کنید' },
  SCORE_CONFIRMED: { label: 'نتیجه مچ تأیید شد' },
  MATCH_COMPLETED: { label: 'نتیجه مچ تأیید شد' },
  SCORE_DISPUTED: { label: 'نتیجه مچ مورد اعتراض قرار گرفت', hint: 'جزئیات را ببینید' },
  SCORE_CORRECTED: { label: 'تیم مقابل نتیجه را اصلاح کرد', hint: 'لطفاً تأیید یا اصلاح کنید' },
  SCORE_AUTO_FINALIZED: { label: 'نتیجه مچ به‌صورت خودکار نهایی شد' },
  TOURNAMENT_REGISTRATION_EXPIRED: { label: 'مهلت ثبت‌نام تورنمنت به پایان رسید' },
  TOURNAMENT_CREATED: { label: 'تورنمنت جدید ایجاد شد', hint: 'برای مشاهده و ثبت‌نام وارد شوید' },
}

export const gameNotificationLabel = (type: string) => GAME_NOTIFICATION_TEXT[type]?.label || 'اعلان جدید'
export const gameNotificationHint = (type: string) => GAME_NOTIFICATION_TEXT[type]?.hint || ''

let started = false

export const useGameNotifications = () => {
  const unreadCount = useState<number>('game-notification-unread-count', () => 0)
  const refreshUnreadCount = async () => {
    try {
      unreadCount.value = await getUnreadCount()
    } catch {
      // keep the last known value
    }
  }

  const startPolling = () => {
    if (!import.meta.client || started) return
    started = true
    const refreshIfVisible = () => {
      if (document.visibilityState === 'visible') refreshUnreadCount()
    }
    setInterval(refreshIfVisible, POLL_INTERVAL_MS)
    window.addEventListener('focus', refreshIfVisible)
    document.addEventListener('visibilitychange', refreshIfVisible)
    useRouter().afterEach(() => refreshIfVisible())
  }

  return { unreadCount, refreshUnreadCount, startPolling }
}
